import { render, staticRenderFns } from "./KilometerRegistrationEdit.vue?vue&type=template&id=3f52d072&scoped=true"
import script from "./KilometerRegistrationEdit.vue?vue&type=script&lang=js"
export * from "./KilometerRegistrationEdit.vue?vue&type=script&lang=js"
import style1 from "./KilometerRegistrationEdit.vue?vue&type=style&index=1&id=3f52d072&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f52d072",
  null
  
)

export default component.exports